(function(){
  function init(){
    var root=document.querySelector('[data-lgw]');
    if(!root) return;
    var form=root.querySelector('.lgw__form'),edit=root.querySelector('[data-lgw-step="edit"]'),confirm=root.querySelector('[data-lgw-step="confirm"]');
    var result=root.querySelector('[data-lgw-result]');
    if(result){result.focus();return}
    if(!form||!edit||!confirm)return;
    var first=root.querySelector('[data-lgw-first]'),last=root.querySelector('[data-lgw-last]'),email=root.querySelector('#lgw-email'),
        order=root.querySelector('[data-lgw-order]'),date=root.querySelector('[data-lgw-date]'),contract=root.querySelector('[data-lgw-contract]'),extra=root.querySelector('[data-lgw-extra]'),
        review=root.querySelector('[data-lgw-review]'),back=root.querySelector('[data-lgw-back]'),nameHidden=root.querySelector('[data-lgw-full-name]'),
        bodyHidden=root.querySelector('[data-lgw-body]'),timeHidden=root.querySelector('[data-lgw-timestamp]'),finalBtn=root.querySelector('[data-lgw-final]');
    var confirmed=false;
    function value(el){return(el&&el.value||'').trim()}
    function put(selector,s){var el=root.querySelector(selector);if(el)el.textContent=s}
    function fill(){
      var fullName=[value(first),value(last)].join(' ').trim();
      var details=[value(contract),value(order)?'Numéro de commande : '+value(order):'',value(date)?'Date d’achat : '+value(date):''].filter(Boolean).join('\n');
      put('[data-lgw-review-name]',fullName);
      put('[data-lgw-review-email]',value(email));
      put('[data-lgw-review-contract]',details);
      nameHidden.value=fullName;
      bodyHidden.value='DÉCLARATION DE RÉTRACTATION ÉLECTRONIQUE\nJe vous notifie par la présente ma décision de me rétracter du contrat désigné ci-dessous.\nNom et prénom : '+fullName+'\nEmail de réponse : '+value(email)+'\nIdentification de la commande : '+details+(value(extra)?'\nPrécisions facultatives : '+value(extra):'')+'\nDate et heure de soumission : voir le champ horodatage et l’en-tête de réception du message.';
    }
    function goReview(){
      var inputs=[first,last,email,contract];
      for(var i=0;i<inputs.length;i++){
        if(!inputs[i].checkValidity()){inputs[i].reportValidity();inputs[i].focus();return;}
      }
      if(!form.checkValidity()){form.reportValidity();return;}
      fill();
      edit.hidden=true;confirm.hidden=false;
      confirmed=true;
      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      confirm.scrollIntoView({block:'start',behavior:reduce?'auto':'smooth'});
      var heading=confirm.querySelector('h3');if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true})}
    }
    if(review)review.addEventListener('click',goReview);
    if(back)back.addEventListener('click',function(){confirm.hidden=true;edit.hidden=false;confirmed=false;edit.scrollIntoView({block:'start',behavior:window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});if(first)first.focus({preventScroll:true})});
    form.addEventListener('submit',function(e){
      if(!confirmed){e.preventDefault();goReview();return;}
      fill();
      try{timeHidden.value=new Date().toISOString()+' (heure fournie par le navigateur du client; faire foi de la date de réception du courriel côté vendeur)'}catch(error){timeHidden.value='Horodatage navigateur non disponible'}
      if(finalBtn){finalBtn.setAttribute('aria-busy','true')}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();